import { render, staticRenderFns } from "./ActionRoles.vue?vue&type=template&id=37582c40&scoped=true&lang=pug"
import script from "./ActionRoles.vue?vue&type=script&lang=js"
export * from "./ActionRoles.vue?vue&type=script&lang=js"
import style0 from "./ActionRoles.vue?vue&type=style&index=0&id=37582c40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37582c40",
  null
  
)

export default component.exports